import { useResponsiveValue } from '@theme-ui/match-media';
import React from 'react';
import { ResponsiveStyleValue } from 'theme-ui';

export type UseBreakpointValueArgs<T> = ResponsiveStyleValue<T | null>;
export type UseBreakpointValueReturn<T> = T | false;

function responsiveStyleNullFix<T>(values: Array<T | null>): Array<T> {
    return values.map((value, index) => {
        if (value === null && index > 0) {
            return values[index - 1];
        }
        return value;
    });
}

/* Going to leave this undocumented to avoid usage, but allow for folks to use as a workaround if need be */
export function useBreakpointValue<T>(values: UseBreakpointValueArgs<T>): UseBreakpointValueReturn<T> {
    const fixedValues = React.useMemo(() => {
        return Array.isArray(values) ? responsiveStyleNullFix<T>(values as Array<T | null>) : [values];
    }, [values]);
    const value = useResponsiveValue(fixedValues);
    return value;
}
